export default {"src":"/_next/static/media/share-annsacks.4593d784.svg","height":17,"width":14};